import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../FireInTheHole2";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {FITH2WinConfig} from "../configs/FITH2WinConfig";
import {FITH2Helper} from "../utils/FITH2Helper";

export class WinCountUpPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return !FireInTheHole2.model.gameData.brokeTheBank && !FireInTheHole2.model.isBigWin && FireInTheHole2.model.isWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();
        const isWinBelowStake: boolean = FITH2Helper.isWinBelowStake();
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2);
        }));

        if (!isWinBelowStake) {
            tl.add(FireInTheHole2.totalWinView.show(FITH2WinConfig.getWinConfig()));
            tl.to(this, {duration: 0.01});
            tl.add(() => controller.finish(), "-=1");
        } else {
            tl.add(() => {
                FireInTheHole2.keypadPlugin.setWin(FireInTheHole2.model.gameData.accumulatedRoundWin, true, isWinBelowStake);
                controller.finish();
            });
        }

        if (FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
        }

    }
}
